<template>
  <div class="custom-bg">
      <div class="custom-bg-top">
      	<img class="logo" src="../assets/logo.png" alt="" />
      	<div class="box">
			<img v-if="type == 1" class="box-img" src="../assets/image/youxiu_logo_wenzi@2x.png" alt="" />
			<div v-if="type == 2" class="name">{{$t('all.wangjimima')}}</div>
			<div v-if="type == 3" class="name">{{$t('all.youxiangzhuce')}}</div>
			<div class="box-input">
				<img class="box-input-img" src="../assets/image/denglu_youxiang@2x.png" alt="" />
				<input class="box-input-input" v-model="form.email" type="text" :placeholder="$t('all.qingshuruningdeyouxiangzhanghao')" placeholder-style="color:rgba(255,255,255,0.6)"/>
			</div>
			<div class="box-yzm" v-if="type != 1">
				<div class="box-input1">
					<img class="box-input-img" src="../assets/image/denglu_yanzhengma@2x.png" alt="" />
					<input class="box-input-input" v-model="form.loginEmailCode" type="text" :placeholder="$t('all.qingshuruyanzhengma')" placeholder-style="color:rgba(255,255,255,0.6)"/>
				</div>
				<div class="huoqu" @click="getCode">{{countdown?timeText:$t('all.huoquyanzhengma')}}</div>
			</div>
			<div class="box-input">
				<img class="box-input-img" src="../assets/image/denglu_mima@2x.png" alt="" />
				<input autocomplete="new-password" class="box-input-input" v-if="!isPassword" v-model="form.password" type="text" :placeholder="type===1?$t('all.qingshurumima'):$t('all.shezhixinmima')" placeholder-style="color:rgba(255,255,255,0.6)"/>
				<input autocomplete="new-password" class="box-input-input" v-if="isPassword" v-model="form.password" type="password" :placeholder="type===1?$t('all.qingshurumima'):$t('all.shezhixinmima')" placeholder-style="color:rgba(255,255,255,0.6)"/>
				<img class="box-input-img" src="../assets/image/denglu_yincang@2x.png" alt="" v-if="isPassword" @click="isPassword = !isPassword"/>
				<img class="box-input-img" src="../assets/image/denglu_yulan@2x.png" alt="" v-if="!isPassword" @click="isPassword = !isPassword"/>
			</div>
			<div class="remember-row" v-if="type == 1">
				<div class="remember-box">
					<div class="remember-item" @click="toggleRemember">
						<img v-if="isRemember" src="../assets/image/xuanze_16_2@2x.png" alt="" />
						<img v-else src="../assets/image/xuanze_16_1@2x.png" alt="" />
						<span>{{$t('all.jizhuzhanghaomima')}}</span>
					</div>
				</div>
				<div class="wjma" @click="handleWangjimima">{{$t('all.wangjimima')}}？</div>
			</div>
			<div class="wjma" v-if="type == 2" @click="handleMimadenglu">{{$t('all.mimadenglu')}}</div>
			<div class="des" v-if="type != 1">{{$t('all.mimashuoming')}}</div>
			
			<div class="box-input2" v-if="type == 3">
				<img class="box-input-img" src="../assets/image/jbxx_yonghuming@2x.png" alt="" />
				<input class="box-input-input" v-model="form.userName" type="text" :placeholder="$t('all.qingshuruyonghuming')" placeholder-style="color:rgba(255,255,255,0.6)"/>
			</div>
			<div class="modal-content-list-item-des" v-if="type == 3">{{$t('all.yonghumingtishi')}}</div>
			<div class="box-input2" v-if="type == 3">
				<img class="box-input-img" src="../assets/image/jbxx_jiaoyimima@2x.png" alt="" />
				<input autocomplete="new-password" class="box-input-input" v-if="!isPayPassword" v-model="form.payPassword" type="text" :placeholder="$t('all.shezhijiaoyimima')" placeholder-style="color:rgba(255,255,255,0.6)"/>
				<input autocomplete="new-password" class="box-input-input" v-if="isPayPassword" v-model="form.payPassword" type="password" :placeholder="$t('all.shezhijiaoyimima')" placeholder-style="color:rgba(255,255,255,0.6)"/>
				<img class="box-input-img" src="../assets/image/denglu_yincang@2x.png" alt="" v-if="isPayPassword" @click="isPayPassword = !isPayPassword"/>
				<img class="box-input-img" src="../assets/image/denglu_yulan@2x.png" alt="" v-if="!isPayPassword" @click="isPayPassword = !isPayPassword"/>
			</div>
			<div class="modal-content-list-item-des" v-if="type == 3">{{$t('all.jiaoyimimatishi')}}</div>
			<div class="box-input3" v-if="type == 3">
				<img class="box-input-img" :src="form.countryImage" alt="" />
				<div class="xian"></div>
				<!-- <div class="countryName">{{form.countryName}}</div> -->
				<el-select v-model="form.countryId" filterable :placeholder="$t('all.qingxuanze')" style="width: 100%;">
					<el-option
					  v-for="item in allCountryList"
					  :key="item.id"
					  :label="item.name"
					  :value="item.id">
					</el-option>
				</el-select>
			</div>
			<div class="box-input2" v-if="type == 3">
				<input class="box-input-input1"  v-model="form.invitationCode" type="text" :placeholder="$t('all.qingshuruyaoqingma')" placeholder-style="color:rgba(255,255,255,0.6)"/>
			</div>
			
			<div class="xieyi" @click="isFlag = !isFlag" v-if="type !=2">
				<img v-if="!isFlag" src="../assets/image/xuanze_16_1@2x.png" alt="" />
				<img v-if="isFlag" src="../assets/image/xuanze_16_2@2x.png" alt="" />
				<span class="xieyi-span">{{$t('all.woyiyuedubingtongyi')}}</span>
				<span class="xieyi-span1" @click.stop="handleShowModel(1)">《{{$t('all.yonghuxieyi')}}》、</span>
				<span class="xieyi-span1" @click.stop="handleShowModel(2)">《{{$t('all.yinsixieyi')}}》</span>
			</div>
			<div class="btn" v-if="type == 1" @click="toLogin">{{$t('all.denglu')}}</div>
			<div class="btn" v-if="type == 2" @click="toForgetPassword">{{$t('all.chongxindenglu')}}</div>
			<div class="btn" v-if="type == 3" @click="toRegister">{{$t('all.zhuce')}}</div>
			<div class="zhuce" v-if="type == 1" @click="handleZhuce(3)">
				<span class="zhuce-span">{{$t('all.haimeizhanghao')}}？</span>
				<span class="zhuce-span1">{{$t('all.quzhuce')}}</span>
			</div>
			<div class="zhuce" v-if="type == 3" @click="handleZhuce(1)">
				<span class="zhuce-span">{{$t('all.yiyouzhanghao')}}，</span>
				<span class="zhuce-span1">{{$t('all.qudenglu')}}</span>
			</div>
      	</div>
      </div>
	  <div class="custom-bg-bottom">
	  	<div class="custom-bg-bottom-xy">
	  		<span class="custom-bg-bottom-xy-span" @click="handleShowModel(1)">{{$t('all.yonghuxieyi')}}</span>
	  		<span class="custom-bg-bottom-xy-span" @click="handleShowModel(2)">{{$t('all.yinsixieyi')}}</span>
			<div class="custom-bg-bottom-xy-div">
				<el-popover
				  placement="top"
				  trigger="click"
				  v-model="isYyPopoverVisible">
				  <div class="custom-bg-bottom-xy-div-model">
				  	<div :class="yyListIndex===index?'custom-bg-bottom-xy-div-model-item':'custom-bg-bottom-xy-div-model-item1'" v-for="(item,index) in yyList" :key="index" @click="handleChooseYy(index,item.language)">{{item.name}}</div>
				  </div>
				  <span class="custom-bg-bottom-xy-span" slot="reference">{{$t('all.yuyanxuanze')}}</span>
				</el-popover>
			</div>
			<span class="custom-bg-bottom-xy-span" @click="handleShowXiazai">{{$t('all.appxiazai')}}</span>
	  	</div>
		<div class="custom-bg-bottom-des">COPYRIGHT © 2026 WWW.UNISHOW.LIVE</div>
	  </div>
	  
	  <!-- 遮罩层和弹窗 -->
	  <div class="modal-overlay" v-if="isModalVisible" @click="isModalVisible = false"></div>
	  <div class="modal-content" v-if="isModalVisible">
		<div class="modal-content-title">{{$t('all.shezhijibenxinxi')}}</div>
		<div class="modal-content-des">{{$t('all.nichengtishi')}}</div>
		<div class="modal-content-list">
			<div class="modal-content-list-item">
				<div class="modal-content-list-item-title">{{$t('all.shezhiyonghuming')}}</div>
				<div class="box-input2">
					<img class="box-input-img" src="../assets/image/jbxx_yonghuming@2x.png" alt="" />
					<input class="box-input-input" v-model="form.userName" type="text" :placeholder="$t('all.qingshuruyonghuming')" placeholder-style="color:rgba(255,255,255,0.6)"/>
				</div>
				<div class="modal-content-list-item-des">{{$t('all.yonghumingtishi')}}</div>
			</div>
			<div class="modal-content-list-item">
				<div class="modal-content-list-item-title">{{$t('all.shezhijiaoyimima')}}</div>
				<div class="box-input2">
					<img class="box-input-img" src="../assets/image/jbxx_jiaoyimima@2x.png" alt="" />
					<input class="box-input-input" v-if="!isPayPassword" v-model="form.payPassword" type="text" :placeholder="type===1?$t('all.qingshurumima'):$t('all.shezhixinmima')" placeholder-style="color:rgba(255,255,255,0.6)"/>
					<input class="box-input-input" v-if="isPayPassword" v-model="form.payPassword" type="password" :placeholder="type===1?$t('all.qingshurumima'):$t('all.shezhixinmima')" placeholder-style="color:rgba(255,255,255,0.6)"/>
					<img class="box-input-img" src="../assets/image/denglu_yincang@2x.png" alt="" v-if="isPayPassword" @click="isPayPassword = !isPayPassword"/>
					<img class="box-input-img" src="../assets/image/denglu_yulan@2x.png" alt="" v-if="!isPayPassword" @click="isPayPassword = !isPayPassword"/>
				</div>
				<div class="modal-content-list-item-des">{{$t('all.jiaoyimimatishi')}}</div>
			</div>
		</div>
		<div class="modal-content-list">
			<div class="modal-content-list-item">
				<div class="modal-content-list-item-title">{{$t('all.xuanzeningdeguojia')}}</div>
				<div class="box-input3">
					<img class="box-input-img" :src="form.countryImage" alt="" />
					<div class="xian"></div>
					<!-- <div class="countryName">{{form.countryName}}</div> -->
					<el-select v-model="form.countryId" filterable :placeholder="$t('all.qingxuanze')" style="width: 100%;">
					    <el-option
					      v-for="item in allCountryList"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
					</el-select>
				</div>
			</div>
			<div class="modal-content-list-item">
				<div class="modal-content-list-item-title">{{$t('all.yaoqingma')}}</div>
				<div class="box-input2">
					<input class="box-input-input1"  v-model="form.invitationCode" type="text" :placeholder="$t('all.qingshuruyaoqingma')" placeholder-style="color:rgba(255,255,255,0.6)"/>
				</div>
			</div>
		</div>
		<div class="btn"  @click="toRegister">{{$t('all.zhuce')}}</div>
	  </div>
	  <xieyi ref="xieyi"/>
	  <xiazai ref="xiazai"/>
  </div>
</template>

<script>
  import { toForgetPassword,sendSmsCode,toLogin,toRegister,getAllCountry } from '@/api/login';
  import { getPresentUserInfo,getMsgUnreadCount } from '@/api/user';
  import xieyi from "../components/xieyi/xieyi.vue"
  import xiazai from "../components/xiazai/xiazai.vue"
  import Cookies from 'js-cookie';
  export default {
	components: {
	  xieyi,
	  xiazai
	},
    data() {
      return {
		type:1,// 1 密码登录 2 忘记密码 3 注册
		countdown: false,
		timeText:60,
		countdownStartTime: 60,
		timer:null,
		form:{
			email:'',
			password:'',
			loginEmailCode:'',
			smsType:1,
			countryId:'',
			countryName:'',
			countryImage:'',
			payPassword:'',
			userName:'',
			invitationCode:''
		},
		isPassword:true,
		isPayPassword:true,
		isFlag:false,
		newWindow:null,
		isModalVisible: false,
		allCountryList:[],
		yyList:[{
		  name:this.$t('all.jiantizhongwen'),
		  language:'cn'
		},{
		  name:this.$t('all.fantizhongwen'),
		  language:'tw'
		},{
		  name:this.$t('all.yingwen'),
		  language:'en'
		},{
		  name:this.$t('all.ribenyu'),
		  language:'ja'
		},{
		  name:this.$t('all.hanguoyu'),
		  language:'ko'
		}],
		yyListIndex:0,
		isModelYy:false,
		isYyPopoverVisible:false,
		isRemember:false
      };
    },
	mounted(){
		this.getAllCountry()
		const lang = localStorage.getItem('Language')
		this.yyListIndex = lang==='cn'?0 : lang==='tw'?1 : lang==='en'?2 : lang==='ja'?3:4
		this.loadRememberedCredentials()
	},
    methods: {
	  loadRememberedCredentials(){
		const remember = localStorage.getItem('rememberUser')
		this.isRemember = remember === 'true'
		if(this.isRemember){
			const savedEmail = localStorage.getItem('savedEmail')
			const savedPassword = localStorage.getItem('savedPassword')
			if(savedEmail){
				this.form.email = savedEmail
			}
			if(savedPassword){
				this.form.password = savedPassword
			}
		}
	  },
	  toggleRemember(){
		this.isRemember = !this.isRemember
		localStorage.setItem('rememberUser', this.isRemember)
		if(!this.isRemember){
			localStorage.removeItem('savedEmail')
			localStorage.removeItem('savedPassword')
		}
	  },
	  saveRememberedCredentials(){
		if(this.isRemember){
			localStorage.setItem('savedEmail', this.form.email)
			localStorage.setItem('savedPassword', this.form.password)
		}
	  },
	  //选择国家
	  getAllCountry(){
		getAllCountry().then(response => {
		  this.allCountryList = response.data
		  this.form.countryId = response.data[0].id
		  this.form.countryName = response.data[0].name
		  this.form.countryImage = response.data[0].picture
		});
	  },
	  //登录
	  toLogin(){
		if(!this.isFlag){
			this.$message.error(this.$t('all.qingyuedubingtongyiyonghuxieyiheyinsixieyi'));
			return
		}
		this.$store.commit('changeToken', '')
		toLogin(this.form).then(response => {
		  sessionStorage.setItem('user', 1);
		  this.$message.success(response.msg);
		  this.$store.commit('changeToken', response.data.token); // 调用 setCount mutation 并传递参数
		  this.$store.commit('changeUserId', response.data.userId); // 调用 setCount mutation 并传递参数
		  this.$store.commit('changeCount', 2); // 调用 setCount mutation 并传递参数
		  this.saveRememberedCredentials()
		  this.getPresentUserInfo()
		  this.getMsgUnreadCount()
		});
	  },
	  //重新登录
	  toForgetPassword(){
		this.$store.commit('changeToken', '')
		toForgetPassword(this.form).then(response => {
		  sessionStorage.setItem('user', 1);
		  this.$message.success(response.msg);
		  this.$store.commit('changeToken', response.data.token); // 调用 setCount mutation 并传递参数
		  this.$store.commit('changeUserId', response.data.userId); // 调用 setCount mutation 并传递参数
		  this.$store.commit('changeCount', 2); // 调用 setCount mutation 并传递参数
		  this.getPresentUserInfo()
		  this.getMsgUnreadCount()
		});
	  },
	  //注册
	  toRegister(){
		if(!this.isFlag){
			this.$message.error(this.$t('all.qingyuedubingtongyiyonghuxieyiheyinsixieyi'));
			return
		}
		this.$store.commit('changeToken', '')
		toRegister(this.form).then(response => {
		  sessionStorage.setItem('user', 1);
		  this.$message.success(response.msg);
		  this.$store.commit('changeToken', response.data.token); // 调用 setCount mutation 并传递参数
		  this.$store.commit('changeUserId', response.data.userId); // 调用 setCount mutation 并传递参数
		  this.$store.commit('changeCount', 2); // 调用 setCount mutation 并传递参数
		  this.getPresentUserInfo()
		  this.getMsgUnreadCount()
		});
	  },
	  //用户详情
	  getPresentUserInfo(){
		getPresentUserInfo().then(response => {
		  this.$store.commit('changeUserInfo', response.data);
		  this.$router.replace({ path: '/shouye' });
		});
	  },
	  //忘记密码
	  handleWangjimima(){
		  this.type = 2
		  this.form.smsType = 2
		  this.form.password = ''
		  this.clearTime()
	  },
	  //密码登录
	  handleMimadenglu(){
		  this.type = 1
		  this.form.smsType = 1
		  this.form.password = ''
		  this.clearTime()
	  },
	  //获取验证码
	  getCode(){
		sendSmsCode(this.form).then(response => {
		  this.$message.success(response.msg);
		  this.countDown();
		  this.countdown = true;
		});
	  },
	  //倒计时
	  countDown() {
		let nowTime = this.timeText - 1;
		console.log(nowTime,'nowTime')
		if (nowTime >= 0) {
			this.timeText = nowTime;
			this.timer = setTimeout(this.countDown, 1000);
		} else {
			this.clearTime()
		}
	  },
	  clearTime(){
		this.countdown = false;
		this.timeText = this.countdownStartTime;
		if (this.timer) {
		  clearTimeout(this.timer);
		  this.timer = null;
		} 
	  },
	  //去注册//登录
	  handleZhuce(data){
		  this.type = data
		  this.form.password = ''
		  this.form.payPassword = ''
		  this.clearTime()
	  },
	  //协议
	  handleShowModel(data){
		  this.$refs.xieyi.showModel(data)
	  },
	  //显示下载弹框
	  handleShowXiazai(){
		this.$refs.xiazai.showModel()
	  },
	  //选择语言
	  handleChooseYy(index,language){
	  	this.yyListIndex = index
	  	this.$i18n.locale = language;
	  	localStorage.setItem("Language",language);
	  	let langStr = 'chinese'
	  	if(language === 'en') langStr = 'english'
	  	else if(language === 'tw') langStr = 'taiwan'
	  	else if(language === 'ja') langStr = 'japanese'
	  	else if(language === 'ko') langStr = 'korean'
	  	this.$store.commit('changeLanguage', langStr);
	  	this.isYyPopoverVisible = false
	  },
	  //未读消息数量
	  getMsgUnreadCount(){
	  	getMsgUnreadCount().then(response => {
		  this.$store.commit('changeSysMsgCount', response.data.sysMsgNoReadCount); // 调用 setCount mutation 并传递参数
	  	});
	  },
	  
    }
  }

</script>

<style lang="scss" scoped>
    .custom-bg {
        min-height: 100vh;
	    background: #161823;
	    display: flex;
	    flex-direction: column;
	    justify-content: space-between;
    }
	.custom-bg-top{
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		padding: 0px 8%;
		flex: 1;
	}
	.left{
		display: flex;
		flex-direction: column;
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 42px;
		color: #FFFFFF;
		text-shadow: 0px 4px 8px rgba(0,0,0,0.3);
		line-height: 56px;
	}
	.logo{
		width: 25%;
	}
	.box{
		background: #252632;
		box-shadow: 0px 4px 48px 0px #0D0E16;
		border-radius: 40px 40px 40px 40px;
		padding: 40px;
        display: flex;
		flex-direction: column;
		align-items: center;
		margin: 50px 0px;
	}
	.box-img{
		width: 241px;
		margin-bottom: 20px;
	}
	.name{
		font-family: MiSans, MiSans;
		font-weight: bold;
		font-size: 42px;
		color: #FFFFFF;
		line-height: 56px;
		padding-bottom: 8px;
	}
	.box-input{
		margin-top: 28px;
		width: 340px;
		height: 66px;
		background: #33343F;
		border-radius: 36px 36px 36px 36px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		padding: 0px 20px;
	}
	.box-input-img{
		width: 26px;
	}
	.box-input-input{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 16px;
		color: rgba(255,255,255,1);
		line-height: 66px;
		height: 66px;
		width: 100%;
		padding: 0px 15px;
		background: none;
		border: none;
		outline: none;
	}
	.box-input-input1{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 16px;
		color: rgba(255,255,255,1);
		line-height: 66px;
		height: 66px;
		width: 100%;
		background: none;
		border: none;
		outline: none;
	}
	.box-yzm{
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		margin-top: 28px;
	}
	.box-input1{
		width: 178px;
		height: 66px;
		background: #33343F;
		border-radius: 36px 36px 36px 36px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		padding: 0px 20px;
	}
	.huoqu{
		width: 146px;
		height: 66px;
		background: #0A99F3;
		border-radius: 36px 36px 36px 36px;
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 66px;
		text-align: center;
		cursor: pointer;
		margin-left: 16px;
	}
	.des{
		margin-top: 14px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: rgba(255,255,255,0.6);
		line-height: 19px;
		max-width: 480px;
		text-align: center;
	}
	.remember-row{
		margin-top: 20px;
		width: 340px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}
	.remember-box{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.remember-item{
		display: flex;
		flex-direction: row;
		align-items: center;
		cursor: pointer;
		margin: 0;
	}
	.remember-item img{
		width: 18px;
		margin-right: 5px;
	}
	.remember-item span{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: rgba(255,255,255,0.6);
	}
	.wjma{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: rgba(255,255,255,0.6);
		line-height: 20px;
		cursor: pointer;
		margin-right: 20px;
	}
	.btn{
		width: 380px;
		height: 66px;
		background: linear-gradient( 81deg, #369AFF 0%, #8200CB 88.07%);
		border-radius: 36px 36px 36px 36px;
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 18px;
		color: #FFFFFF;
		text-align: center;
		line-height: 66px;
		text-align: center;
		cursor: pointer;
		margin-top: 28px;
	}
	.xieyi{
		margin-top: 28px;
		cursor: pointer;
		display: flex;
		flex-direction: row;
		align-items: center;
		width: 340px;
		white-space: pre-wrap;
		word-break: break-all;
		overflow-wrap: break-word;
	}
	.xieyi img{
		width: 18px;
	}
	.xieyi-span{
		cursor: pointer;
		padding-left: 5px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
		line-height: 21px;
		white-space: pre-wrap;
		word-break: break-all;
		overflow-wrap: break-word;
	}
	.xieyi-span1{
		cursor: pointer;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #0A99F3;
		line-height: 21px;
		white-space: pre-wrap;
		word-break: break-all;
		overflow-wrap: break-word;
	}
	.zhuce{
		cursor: pointer;
		margin-top: 28px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}
	.zhuce-span{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
		line-height: 21px;
	}
	.zhuce-span1{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #0A99F3;
		line-height: 21px;
	}
	
	.modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
    }

    .modal-content {
		z-index: 1001;
		position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 860px;
        background: #252632;
        box-shadow: 0px 4px 48px 0px #0D0E16;
        border-radius: 20px;
		padding: 52px 70px;
    }
	.modal-content-title{
		font-family: MiSans, MiSans;
		font-weight: bold;
		font-size: 42px;
		color: #FFFFFF;
		line-height: 56px;
	}
	.modal-content-des{
		padding-top: 9px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: rgba(255,255,255,0.6);
		line-height: 18px;
	}
	.modal-content-list{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding-top: 30px;
	}
	.modal-content-list-item{
		display: flex;
		flex-direction: column;
	}
	.box-input2{
		margin-top: 28px;
		width: 340px;
		height: 66px;
		background: #33343F;
		border-radius: 36px 36px 36px 36px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		padding: 0px 20px;
	}
	.box-input3{
		margin-top: 14px;
		width: 340px;
		height: 66px;
		background: #33343F;
		border-radius: 36px 36px 36px 36px;
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 0px 20px;
		cursor: pointer;
	}
	.modal-content-list-item-title{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 21px;
	}
	.modal-content-list-item-des{
		padding-top: 14px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: rgba(255,255,255,0.6);
		line-height: 19px;
		width: 100%;
		text-align: left;
	}
	.box-input-img1{
		margin-left: 10px;
		width: 14px;
	}
	.xian{
		margin: 0px 20px;
		width: 0px;
		height: 24px;
		border: 0.5px solid #B0B8D2;
	}
	.countryName{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
	}
	.custom-bg-bottom{
		width: 100%;
		height: 66px;
		background: #161823;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.custom-bg-bottom-xy{
		display: flex;
		flex-direction: row;
	}
	.custom-bg-bottom-xy-span{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 12px;
		color: #ffffff;
		padding: 0px 20px;
		cursor: pointer;
	}
	.custom-bg-bottom-xy-span1{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 12px;
		color: #ffffff;
		cursor: pointer;
	}
	.custom-bg-bottom-des{
		padding-top: 6px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
		font-weight: 500;
	}
	.custom-bg-bottom-xy-div{
		
	}
	.custom-bg-bottom-xy-div-model{
		display: flex;
		flex-direction: column;
	}
	.custom-bg-bottom-xy-div-model-item{
		height: 36px;
		background: #0A99F3;
		border-radius: 20px 20px 20px 20px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
		text-align: center;
		line-height: 36px;
		cursor: pointer;
		margin: 6px 0px;
	}
	.custom-bg-bottom-xy-div-model-item1{
		height: 36px;
		background: rgba(255,255,255,0.1);
		border-radius: 20px 20px 20px 20px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: rgba(255,255,255,0.6);
		text-align: center;
		line-height: 36px;
		cursor: pointer;
		margin: 6px 0px;
	}
</style>
<style>
	.el-input__inner{
		background: #33343F;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
		padding-left: 0px;
		border: none;
		outline: none;
	}
	/* 新增：去除浏览器自动填充的背景颜色 */
	/* 兼容webkit/blink内核浏览器（Chrome、Edge、Safari等） */
	input:-webkit-autofill,
	input:-webkit-autofill:hover,
	input:-webkit-autofill:focus,
	input:-webkit-autofill:active,
	/* 你的自定义输入框类名（针对性覆盖，提高权重） */
	.box-input-input:-webkit-autofill,
	.box-input-input1:-webkit-autofill,
	/* Element UI 输入框兼容 */
	.el-input__inner:-webkit-autofill {
		/* 覆盖默认背景色，与你的页面自定义背景保持一致 */
		background-color: #33343F !important;
		/* 覆盖默认文字颜色，与你的输入框文字色保持一致 */
		-webkit-text-fill-color: #ffffff !important;
		/* 取消背景图片（浏览器自动填充可能附带的默认背景） */
		background-image: none !important;
		/* 禁止浏览器修改该元素的样式（关键，防止被浏览器覆盖） */
		-webkit-box-shadow: 0 0 0px 1000px #33343F inset !important;
		/* 继承边框样式（如果有需要） */
		border: none !important;
		/* 提高样式权重，确保生效 */
		color: #ffffff !important;
	}
	
	/* 标准伪类，兼容未来浏览器和非webkit内核（可选补充） */
	input:autofill,
	input:autofill:hover,
	input:autofill:focus,
	.box-input-input:autofill,
	.box-input-input1:autofill,
	.el-input__inner:autofill {
		background-color: #33343F !important;
		color: #ffffff !important;
		border: none !important;
	}
	.el-popover{
		background: #33343F;
		border: none;
	}
	.el-popover .popper__arrow{
		border-top-color:#33343F;
	}
</style>


// WEBPACK FOOTER //
// Login.vue?8708c69c